import { render, staticRenderFns } from "./BaseMainLeftMenuItem.vue?vue&type=template&id=1aa6c38a&scoped=true&"
import script from "./BaseMainLeftMenuItem.vue?vue&type=script&lang=js&"
export * from "./BaseMainLeftMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseMainLeftMenuItem.vue?vue&type=style&index=0&id=1aa6c38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa6c38a",
  null
  
)

export default component.exports